import { AppRoutingModule } from './../app-routing.module';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';
import { ModalConfirmacaoComponent } from './modal-confirmacao/modal-confirmacao.component';
import { ModalAlertaComponent } from './modal-alerta/modal-alerta.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardBoxComponent } from './card-box/card-box.component';
import { ProgressComponent } from './progress/progress.component';
import { ModalAjudaComponent } from './modal-ajuda/modal-ajuda.component';
import { SpinnerComponent } from './components/spinner/spinner.component';

@NgModule({
    imports: [CommonModule, MatCardModule, NgxLoadingModule, AppRoutingModule],
    declarations: [
        ModalAlertaComponent,
        ModalAjudaComponent,
        ModalConfirmacaoComponent,
        CardBoxComponent,
        ProgressComponent,
        ModalAjudaComponent,
        SpinnerComponent,
    ],
    exports: [
        ModalAlertaComponent,
        ModalAjudaComponent,
        ModalConfirmacaoComponent,
        CardBoxComponent,
    ]
})
export class SharedModule {}
